
const Main = () => import('@/views/main');
const role = () => import('@/views/jurisdiction/role');
const user = () => import('@/views/jurisdiction/user');

export default [{
    path: '/jurisdiction',
    name: 'jurisdiction',
    component: Main,
	redirect: {
		name: 'role'
	},
    meta: {
        hide: false,
        name: '权限管理',
        unfold: true,
        iconType: "11",
    },
    children: [
        {
            path: 'role',
            name: 'role',
            component: role,
            meta: {
                name: '角色管理'
            },
            children: [
                {
                    path: 'addRole',
                    name: 'addRole',
                    component: () => import('@/views/jurisdiction/addRole'),
                    meta: {
                        name: '新增角色'
                    },
                },
                {
                    path: 'editRole',
                    name: 'editRole',
                    component: () => import('@/views/jurisdiction/addRole'),
                    meta: {
                        name: '编辑角色'
                    },
                },
                {
                    path: 'detailRole',
                    name: 'detailRole',
                    component: () => import('@/views/jurisdiction/addRole'),
                    meta: {
                        name: '角色详情'
                    },
                },
            ]
        },
        {
            path: 'user',
            name: 'user',
            component: user,
            meta: {
                name: '员工管理'
            },
            children: [
                {
                    path: 'addUser',
                    name: 'addUser',
                    component: () => import('@/views/jurisdiction/addUser'),
                    meta: {
                        name: '新增员工'
                    },
                },
                {
                    path: 'editUser',
                    name: 'editUser',
                    component: () => import('@/views/jurisdiction/addUser'),
                    meta: {
                        name: '编辑员工'
                    },
                },
            ]
        },
    ]
}]

